import './FormStyles.css';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser'
import Swal from 'sweetalert2'

const Form = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('gmail', 'template_nvm4pkr', form.current, 'NsFFm4K8Kz2dHDXyo')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      form.current.reset()
  };
  const handleClick = () => {
    Swal.fire({
      position: 'top',
      icon: 'success',
      title: 'SENT SUCCESSFULLY!',
      showConfirmButton: true,
      timer: 2000
    })
  }

  return (
      <form ref={form} className='Form' onSubmit={sendEmail}>
        <label className='mt-4'>Your Name:</label>
        <input type='text' name='name' placeholder='John Smith:' required></input>
        <label>Email Address:</label>
        <input type='email' name='email' placeholder='example123@gmail.com:'></input>
        <label>Subject:</label>
        <input type='text' name='subject' rows='2' placeholder='Howdy partner..'></input>
        <label>Message:</label>
        <textarea name='message' rows='8' placeholder='Type your message here'></textarea>
        
        <button name='button' type='submit' className='Bbtn align-items-center mb-4 mx-3' onClick={handleClick}>Submit</button>
        </form>
  )
}

export default Form